export const IRREGULARITIES_ENDPOINT = 'irregularities'

// Picker of the types the list is filtered by. It hangs under the reports rather
// than under the types codebook, so reading the reports is enough to use it.
export const IRREGULARITY_TYPES_AUTOCOMPLETE_ENDPOINT = `${IRREGULARITIES_ENDPOINT}/types/autocomplete`

export const IRREGULARITIES_TABLE_KEY = 'winter-service-v2-irregularities'
export const IRREGULARITIES_UI_VIEW = 'winter_service2_irregularities'

export const IRREGULARITIES_INDEX_ROUTE = 'WinterService2Irregularities'
export const IRREGULARITY_DETAILS_ROUTE = 'WinterService2IrregularityDetails'

export const IRREGULARITIES_TRANSLATION_NAMESPACE = 'road-maintenance/winter_service2/irregularities'

// The photos the driver's device uploaded with the report, as the backend reports
// them - a list of { id, file_name, url }. Read-only here, shown in a carousel.
export const IRREGULARITY_PHOTOS_KEY = 'photos'
